import React from 'react';
import { ActivityIndicator } from 'react-native';
import styled from 'styled-components/native';
import { FetchError } from '../../api/api';
import AlertBox from '../../components/AlertBox';
import AppVersionInfo from '../../components/AppVersionInfo';

import Button from '../../components/Button';
import Spacer from '../../components/Spacer';
import { H4, P } from '../../components/Typography';
import Colors from '../../constants/Colors';

const StyledView = styled.View`
  flex: 1;
  background-color: white;
`;

const StyledBackgroundImageView = styled.Image`
  width: 100%;
  height: 100%;
`;

const StyledScrollView = styled.ScrollView`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
`;

const StyledLogo = styled.Image`
  margin-top: 100px;
  height: 152.73px;
  width: 187.2px;
  align-self: center;
`;

const StyledButtonView = styled.View`
  align-self: center;
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  max-width: 430px;
`;

const StyledTitle = styled(H4)`
  align-self: center;
  color: ${Colors.primary};
  width: 100%;
  margin-top: 52px;
  max-width: 282px;
`;

const StyledDescription = styled(P)`
  align-self: center;
  width: 100%;
  margin-top: 16px;
  color: ${Colors.primary};
  max-width: 282px;
  margin-bottom: 24px;
`;

const StyledErrorView = styled.View`
  max-width: 420px;
  padding: 24px;
  align-self: center;
`;

const TodayEmptyStateView: React.FC<{
  title: string;
  description: string;
  buttonLabel: string;
  disabled?: boolean;
  loading?: boolean;
  error?: FetchError;
  isPendingStudy?: boolean;
  onButtonPressed?: () => void;
}> = ({
  title,
  description,
  buttonLabel,
  disabled,
  loading,
  error,
  isPendingStudy,
  onButtonPressed
}) => {
  return (
    <StyledView>
      <StyledBackgroundImageView
        resizeMode='cover'
        source={require('../../assets/today-empty-state/background-image.png')}
      />
      <StyledScrollView>
        <StyledLogo
          source={require('../../assets/today-empty-state/people-science-logo.png')}
        />
        <StyledTitle accessibilityLabel={title} center>
          {title}
        </StyledTitle>
        <StyledDescription center>{description}</StyledDescription>
        {!isPendingStudy && (
          <StyledButtonView>
            <Button
              disabled={disabled}
              color='secondary'
              endIcon={loading && <ActivityIndicator />}
              onPress={onButtonPressed}
            >
              {buttonLabel}
            </Button>
          </StyledButtonView>
        )}
        {!!error && (
          <StyledErrorView>
            <AlertBox severity='error'>{error.message}</AlertBox>
          </StyledErrorView>
        )}
        <Spacer size={4} />
        <AppVersionInfo />
        <Spacer size={4} />
      </StyledScrollView>
    </StyledView>
  );
};

export default TodayEmptyStateView;
